// Interfaces
import { IRouteParent } from 'routes/route.interface'

/**
 * @description Filter route by roles but parent
 *
 * @param {IRouteParent[]} routes
 * @param {number[]} accessCodes
 *
 * @return {IRouteParent[]} IRouteParent[]
 */
export const routeUtils_filterRouteParent = (routes: IRouteParent[], accessCodes: number[]): IRouteParent[] => {
  const mapRoutes = routes.map(route => ({ ...route, children: routeUtils_filterRouteByRoles(route.children, accessCodes) }))
  const filterByRoles = routeUtils_filterRouteByRoles(mapRoutes, accessCodes)

  return filterByRoles
}

/**
 * @description Filter route by roles
 *
 * @param {IRoute[]} routes
 * @param {number[]} accessCodes
 *
 * @return {IRoute} IRoute[]
 */
export const routeUtils_filterRouteByRoles = (routes: any, accessCodes: number[]): any => {
  if (accessCodes.length > 0) {
    return routes.filter((route: any) =>
      route.meta.attrs?.accessCodes?.some((accessCode: number) => accessCodes.includes(accessCode)),
    )
  } else {
    // Force return the profile route
    return routes.filter((route: any) => route.meta.attrs?.accessCodes?.some((accessCode: number) => accessCode === 222))
  }
}
